var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"category-tree"},_vm._l((_vm.tree),function(item){return _c('CategoryTreeItem',{key:item.id,attrs:{"item":item,"root":true,"on-delete":_vm.onDelete,"on-sort":_vm.onSort}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }